import script from "./NotFoundView.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotFoundView.vue?vue&type=script&lang=ts&setup=true"

import "./NotFoundView.vue?vue&type=style&index=0&id=446c3f4e&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/jobs/MYNAVI_MP_VIEW_G_PROD/workspace/view/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-446c3f4e"]])

export default __exports__